import React from 'react';
import Wheel from '../Step2/SelectGoals/Wheel';
import { buildDemoStep2WheelState } from './marketingStepDemoData';
import '../Step2/SelectGoals/Wheel.css';
import '../Step1/Question/Question.css';
import '../Step1/Wheel/Pie.css';
import './MarketingAssets.css';

/**
 * Production Step 2 Wheel only — same component as OolaSevenSection / pick7 preview.
 * Square wrapper prevents SVG stretch in marketing capture frames.
 */
const MarketingOolaWheel = ({ allState }) => {
    const wheelState = allState || buildDemoStep2WheelState();

    return (
        <div className="selectGoalTop7__wrapperWheel marketing-oola-wheel-origin">
            <Wheel
                AllState={wheelState}
                hideNav={false}
                allColors
                confetti={0}
                maskId="marketing-step2-wedge-mask"
                overlayId="marketing-step2-wheel-overlay"
            />
        </div>
    );
};

export default MarketingOolaWheel;
